import { useCallback } from 'react';
import { type Section } from '#shared/api/schema';
import { useYandexKit } from '#shared/components/YandexKitProvider';

export const useConstructorMigrateSectionSettings = () => {
    const { migrateSectionSettings } = useYandexKit();

    return useCallback(
        (section: string, settings: unknown) => {
            if (migrateSectionSettings) {
                return migrateSectionSettings(section, settings);
            }

            return settings as Section['settings'];
        },
        [migrateSectionSettings]
    );
};
